'use client';

const CLOSE_BUTTON_LABEL = "Close modal";
export {
  CLOSE_BUTTON_LABEL
};
